import React from 'react'
import SettingsScreen from './SettingsScreen'

import './SettingsButton.scss'

class SettingsButton extends React.Component<{}> {
  public render(): JSX.Element {
    return (
      <div className="SettingsButton dropdown">
        <button
          className="btn btn-secondary dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          id="settingsMenuButton"
        >
          <i className="fas fa-cog mr-1 mr-sm-2" />
          Settings
        </button>
        <div className="dropdown-menu" aria-labelledby="settingsMenuButton">
          <div className="px-3 py-3">
            <SettingsScreen />
          </div>
        </div>
      </div>
    )
  }
}

export default SettingsButton
